export const parseTime = (t) => {
    const match = t.match(/^(\d{1,2}):(\d{2})\s*(am|pm|AM|PM)?$/);
    if (!match) return [0, 0];
    let hour = Number(match[1]);
    const minute = Number(match[2]);
    const period = match[3]?.toLowerCase();
    if (period === 'pm' && hour < 12) hour += 12;
    if (period === 'am' && hour === 12) hour = 0;
    return [hour, minute];
};